import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { BehaviorSubject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ApplicationModeService {
    private applicationModeSubject = new BehaviorSubject<string>(undefined);
    applicationMode$ = this.applicationModeSubject.asObservable();

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) {}

    setApplicationMode(mode: string) {
        this.applicationModeSubject.next(mode);
    }

    clearApplicationMode() {
        this.applicationModeSubject.next(undefined);
    }

    getApplicationMode(fallBackToQueryParams: boolean): string {
        let val = this.applicationModeSubject.value;
        if (fallBackToQueryParams && !val) {
            const queryParams = this.route.snapshot.queryParams;
            if (queryParams && queryParams['applicationMode']) {
                val = queryParams['applicationMode'];
                // Update the BehaviorSubject with the value from query params
                this.applicationModeSubject.next(val);
            }
        }

        // If still undefined, default to 'readOnly'
        if (!val) {
            val = 'readOnly';
            // Update the BehaviorSubject with the value from query params
            this.applicationModeSubject.next(val);
        }

        return val;
    }
}
